module.exports = __webpack_public_path__ + "static/media/Lato-Thin.13fa4c60.woff";